import { GameId, StoreOfferProduct } from '@common'

import { BrawlValueIndicator } from '../valueIndicator/BrawlValueIndicator'
import { ClashValueIndicator } from '../valueIndicator/ClashValueIndicator'
import { RoyaleValueIndicator } from '../valueIndicator/RoyaleValueIndicator'

type BundleProps = {
  children?: React.ReactNode
  game: GameId
  offerProduct: StoreOfferProduct
}

export const OfferValueBadge = ({ offerProduct: product, game }: BundleProps) => {
  const valueTagStrings =
    game === 'clashroyale'
      ? ['scroll:multiplier:']
      : game === 'brawlstars'
        ? ['laser:valueMultiplier:']
        : game === 'clashofclans'
          ? ['magic:value']
          : []
  const valueTag = product?.tags?.find((tag) => valueTagStrings.some((t) => tag.includes(t)))

  const offerValue = Number(valueTag?.split(':').filter(Boolean).pop())
  const hasValue = !isNaN(offerValue) && offerValue > 0

  if (!hasValue) return null

  if (game === 'brawlstars') {
    return <BrawlValueIndicator value={offerValue} />
  }

  if (game === 'clashroyale') {
    return <RoyaleValueIndicator value={offerValue} />
  }

  return <ClashValueIndicator value={offerValue} />
}

OfferValueBadge.displayName = 'OfferValueBadge'
